const typedErrors: Record<string, string> = {
  AddressNotFoundError: 'Адрес не найден',
  CategoryNotFoundError: 'Категория не найдена',
  PriceNotFoundError: 'Прайс-лист не найден',
  QuestNotFoundError: 'Квест не найден',
  UserNotFoundError: 'Пользователь не найден',
  ServiceNotFoundError: 'Услуга не найдена',
  ScheduleNotFoundError: 'Расписание не найдено',
  ServiceCannotBeDeletedError: 'Невозможно удалить услугу, т.к. она привязана к квесту или странице',
  GiftCardRedeemPinInvalid: 'Неверный ПИН-код подарочной карты',
  GiftCardAlreadyBeenRedeemed: 'Подарочная карта уже была погашена ранее',
  GiftCardIsNotFound: 'Подарочная карта не найдена'
}

export { typedErrors }
